// src/api/verifyService.ts
import { AxiosResponse } from 'axios';
import apiClient from './config';

export async function verifyEmail(token: string): Promise<AxiosResponse> {
  return apiClient.get(`/users/verify?token=${token}`);
}
